var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7915 18.875C15.2502 18.875 16.6491 18.2955 17.6806 17.2641C18.712 16.2326 19.2915 14.8337 19.2915 13.375C19.2915 11.9163 18.712 10.5174 17.6806 9.48591C16.6491 8.45446 15.2502 7.875 13.7915 7.875C12.3328 7.875 10.9339 8.45446 9.90242 9.48591C8.87097 10.5174 8.2915 11.9163 8.2915 13.375C8.2915 14.8337 8.87097 16.2326 9.90242 17.2641C10.9339 18.2955 12.3328 18.875 13.7915 18.875Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.4165 18.875V7.875C1.4165 6.05164 2.14083 4.30295 3.43014 3.01364C4.71946 1.72433 6.46814 1 8.2915 1H19.2915C21.1149 1 22.8636 1.72433 24.1529 3.01364C25.4422 4.30295 26.1665 6.05164 26.1665 7.875V18.875C26.1665 20.6984 25.4422 22.447 24.1529 23.7364C22.8636 25.0257 21.1149 25.75 19.2915 25.75H8.2915C6.46814 25.75 4.71946 25.0257 3.43014 23.7364C2.14083 22.447 1.4165 20.6984 1.4165 18.875Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.354 5.82616L21.3678 5.81104",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c7fc663913dbc56b2bc582d3a8082c18.svg";
export { ForwardRef as ReactComponent };